import * as React from 'react';
import ArtworkFormContainer from 'containers/jinny/ArtworkFormContainer';

const Form = () => {
  return <ArtworkFormContainer />;
};

export default Form;
